import { createSlice, PayloadAction as Action } from "@reduxjs/toolkit";

import { ICategoryTag, Iterable } from "types";

type State = {
  list: Iterable<ICategoryTag>[];
};

const initialState: State = { list: [] };

const slice = createSlice({
  name: "categories",
  initialState: initialState,
  reducers: {
    setCategories: (state, action: Action<State["list"]>) => {
      state.list = action.payload;
    },
  },
});

export const {
  reducer,
  actions: { setCategories },
} = slice;
